module.exports = __webpack_public_path__ + "static/media/DarrenJackson.af292361.png";